import { useMemo } from 'react'
import { useEffect, useState } from 'react'

const useHooks = ({ data }) => {
  const JETTY_LIST = ['H1', 'H2', 'H3', 'P1', 'P2', 'P3']
  const [selectedEquipment, setSelectedEquipment] = useState([])

  const jettyData = useMemo(
    () =>
      data
        ?.filter((item) => item?.detailTable?.Jetty_Name)
        ?.sort((a, b) => b.detailTable?.Percentage - a.detailTable?.Percentage),
    [data]
  )

  const handleClickAccordion = (index) => () => {
    setSelectedEquipment((prevSelected) => {
      const isSelected = prevSelected.includes(index)
      if (isSelected) {
        return prevSelected.filter((item) => item !== index)
      } else {
        return [...prevSelected, index]
      }
    })
  }

  const handleDefaultOpen = () => {
    data
      ?.filter((item) => item?.detailTable?.Vessel_Name)
      ?.forEach((item, index) => {
        if (item?.detailTable?.Vessel_Name) {
          setSelectedEquipment((prevSelected) => [...prevSelected, index])
        }
      })
  }

  useEffect(() => {
    handleDefaultOpen()
  }, [data])

  return {
    data: {
      jettyData,
      JETTY_LIST,
      selectedEquipment
    },
    methods: {
      handleClickAccordion
    }
  }
}

export default useHooks
